import { makeStyles } from 'tss-react/mui';

// Styles
import { cardRoundedShadow } from '../../../styles/global';

export const useStyles = makeStyles()((theme, { isKiteUser } = {}) => ({
  flatButton: { padding: 0, wordWrap: 'none' },
  supportCard: {
    ...cardRoundedShadow,
    width: '267px',
    minWidth: '224px',
    height: '230px',
    padding: '24px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    alignItems: 'start',
    [theme.breakpoints.down('lg')]: {
      height: '226px',
      padding: '20px 16px',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      minWidth: '100%',
      height: '200px',
      padding: '16px',
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        height: '226px',
        padding: '20px 16px',
      }),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        width: '100%',
        minWidth: '100%',
        height: '200px',
        padding: '16px',
      }),
    },
  },
  phoneButton: {
    color: isKiteUser ? theme.palette.primary1 : theme.palette.pressed,
    textDecoration: 'none',
    fontStyle: 'normal',
    ...theme.typography.textSm,
    fontWeight: '400 !important',
    marginLeft: '8px',
  },
  mediaButton: {
    height: '36px',
    backgroundColor: theme.palette.lightGrey,
    '&:hover': {
      backgroundColor: `${theme.palette.lightGrey} !important`,
    },
    fontSize: '14px',
    fontWeight: isKiteUser ? '400' : '600',
    color: isKiteUser ? theme.palette.primary1 : theme.palette.pressed,
    [theme.breakpoints.down('lg')]: {
      height: '34px',
    },
    [theme.breakpoints.down('md')]: {
      width: 264,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        height: '34px',
      }),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        width: 264,
        marginLeft: 'auto',
        marginRight: 'auto',
      }),
    },
  },
  videoButton: {
    marginBottom: theme.spacing(1),
    '& path': {
      fill: isKiteUser ? theme.palette.primary1 : theme.palette.pressed,
    },
  },
  cardIcon: {
    '& > path': {
      fill: isKiteUser ? theme.palette.primary1 : theme.palette.pressed,
    },
  },
}));
